/* tslint:disable */
/* eslint-disable */
/**
 * ReD Admin API Spec
 * ReD中途企業向けサイト用API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: info@redesigner.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GetAccountStatuses200ResponseSystemStatusesAddedScoutsInner } from './GetAccountStatuses200ResponseSystemStatusesAddedScoutsInner';
import {
    GetAccountStatuses200ResponseSystemStatusesAddedScoutsInnerFromJSON,
    GetAccountStatuses200ResponseSystemStatusesAddedScoutsInnerFromJSONTyped,
    GetAccountStatuses200ResponseSystemStatusesAddedScoutsInnerToJSON,
} from './GetAccountStatuses200ResponseSystemStatusesAddedScoutsInner';

/**
 * システムステータス情報
 * @export
 * @interface GetAccountStatuses200ResponseSystemStatuses
 */
export interface GetAccountStatuses200ResponseSystemStatuses {
    /**
     * メッセージ未読がある求職者数
     * @type {number}
     * @memberof GetAccountStatuses200ResponseSystemStatuses
     */
    unreadUserNum: number;
    /**
     * スカウト残数
     * @type {number}
     * @memberof GetAccountStatuses200ResponseSystemStatuses
     */
    scoutRemainNum: number;
    /**
     * スカウト有効期限(YYYY-MM-DD)
     * @type {string}
     * @memberof GetAccountStatuses200ResponseSystemStatuses
     */
    scoutRemainExpireAt: string;
    /**
     * 未チェックの意欲更新求職者数
     * @type {string}
     * @memberof GetAccountStatuses200ResponseSystemStatuses
     */
    uncheckedIntentionUpdatedUsersNum: string;
    /**
     * 未チェックのプロフィール更新求職者数
     * @type {string}
     * @memberof GetAccountStatuses200ResponseSystemStatuses
     */
    uncheckedProfileUpdatedUsersNum: string;
    /**
     * 未閲覧の求人興味あり求職者数
     * @type {number}
     * @memberof GetAccountStatuses200ResponseSystemStatuses
     */
    unseenInterestsJobsV2UsersNum: number;
    /**
     * 追加スカウト枠
     * @type {Array<GetAccountStatuses200ResponseSystemStatusesAddedScoutsInner>}
     * @memberof GetAccountStatuses200ResponseSystemStatuses
     */
    addedScouts: Array<GetAccountStatuses200ResponseSystemStatusesAddedScoutsInner>;
}

/**
 * Check if a given object implements the GetAccountStatuses200ResponseSystemStatuses interface.
 */
export function instanceOfGetAccountStatuses200ResponseSystemStatuses(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "unreadUserNum" in value;
    isInstance = isInstance && "scoutRemainNum" in value;
    isInstance = isInstance && "scoutRemainExpireAt" in value;
    isInstance = isInstance && "uncheckedIntentionUpdatedUsersNum" in value;
    isInstance = isInstance && "uncheckedProfileUpdatedUsersNum" in value;
    isInstance = isInstance && "unseenInterestsJobsV2UsersNum" in value;
    isInstance = isInstance && "addedScouts" in value;

    return isInstance;
}

export function GetAccountStatuses200ResponseSystemStatusesFromJSON(json: any): GetAccountStatuses200ResponseSystemStatuses {
    return GetAccountStatuses200ResponseSystemStatusesFromJSONTyped(json, false);
}

export function GetAccountStatuses200ResponseSystemStatusesFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetAccountStatuses200ResponseSystemStatuses {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'unreadUserNum': json['unread_user_num'],
        'scoutRemainNum': json['scout_remain_num'],
        'scoutRemainExpireAt': json['scout_remain_expire_at'],
        'uncheckedIntentionUpdatedUsersNum': json['unchecked_intention_updated_users_num'],
        'uncheckedProfileUpdatedUsersNum': json['unchecked_profile_updated_users_num'],
        'unseenInterestsJobsV2UsersNum': json['unseen_interests_jobs_v2_users_num'],
        'addedScouts': ((json['added_scouts'] as Array<any>).map(GetAccountStatuses200ResponseSystemStatusesAddedScoutsInnerFromJSON)),
    };
}

export function GetAccountStatuses200ResponseSystemStatusesToJSON(value?: GetAccountStatuses200ResponseSystemStatuses | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'unread_user_num': value.unreadUserNum,
        'scout_remain_num': value.scoutRemainNum,
        'scout_remain_expire_at': value.scoutRemainExpireAt,
        'unchecked_intention_updated_users_num': value.uncheckedIntentionUpdatedUsersNum,
        'unchecked_profile_updated_users_num': value.uncheckedProfileUpdatedUsersNum,
        'unseen_interests_jobs_v2_users_num': value.unseenInterestsJobsV2UsersNum,
        'added_scouts': ((value.addedScouts as Array<any>).map(GetAccountStatuses200ResponseSystemStatusesAddedScoutsInnerToJSON)),
    };
}

